import { AccountUserLimitModelDto as BoAccountUserLimitDto } from '@treasury/api/bo';
import { AccountUserLimitModelDto as ConsumerAccountUserLimitDto } from '@treasury/api/channel';
import { DomainEntity } from '../../../../shared';

const defaultCompanyUserAccountLimit: BoAccountUserLimitDto = {
    id: 0,
    userAccount: {
        id: 0,
        userId: 0,
    },
    userAccountLimit: {
        dailyLimit: 0,
        perTransactionLimit: 0,
    },
    pendingUserAccountLimit: {
        dailyLimit: 0,
        perTransactionLimit: 0,
    },
};
export class CompanyUserAccountLimit extends DomainEntity<
    BoAccountUserLimitDto | ConsumerAccountUserLimitDto
> {
    public get userAccount() {
        return this.dto.userAccount;
    }

    public get userAccountDailyLimit() {
        return this.dto.userAccountLimit;
    }

    public get pendingUserAccountDailyLimit() {
        return this.dto.pendingUserAccountLimit?.dailyLimit;
    }

    public get pendingUserAccountPerTransactionLimit() {
        return this.dto.pendingUserAccountLimit?.perTransactionLimit;
    }

    public createDefault(): this {
        return new CompanyUserAccountLimit(defaultCompanyUserAccountLimit) as this;
    }
}

// export type AccountUserLimitModelDto = ModelBaseDto & {
//     userAccount?: UserAccountModelDto;
//     userAccountLimit?: UserAccountLimitModelDto;
//     pendingUserAccountLimit?: UserAccountLimitModelDto;
//   };
